import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 25084C11-A1EE-4158-BC41-5E80E00E837E
 * name reply-circle
 * version: 4.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/reply-circle.svg
 * tags
 * - Arrow 
 */
export const ReplyCircleIcon = createSvgIcon(<><path d="M2 12C2 17.5 6.5 22 12 22S22 17.5 22 12 17.5 2 12 2 2 6.5 2 12M5 11L10 6V9C15.06 9.73 17.28 13.33 18 17C16.19 14.43 13.61 13 10 13V16L5 11Z" /></>, 'ReplyCircleIcon');
export default ReplyCircleIcon